interface Props {
  apiKey: string;
  onChange: (apiKey: string) => void;
}

export const APIKeyInput: React.FC<Props> = ({ apiKey, onChange }) => {
  return (
    <input
      className="input input-bordered	text-black dark:bg-neutral dark:text-white w-[350px] focus:border-primary focus:outline-none sm:text-sm"
      type="password"
      placeholder="OpenAI API Key"
      autoComplete="off"
      value={apiKey}
      onChange={(e) => onChange(e.target.value)}
    />
  );
};
